// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"8e342c01","163":"1f344431","171":"8d29a2b8","273":"5b146c88","537":"1a6ffda4","645":"453de115","787":"d356e0aa","965":"96a61f7d"}[chunkId] + ".chunk.js";
};